module.exports = __webpack_public_path__ + "static/media/screen.0d0352c4.png";